import { Box, styled } from "@mui/material";

export const ButtonContainer = styled(Box)({
    padding: "0 1rem",
    textAlign: "right",
    marginTop: "1rem",
});
